import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GoBackBtn from '../components/goBackBtn';
import CouponList from '../components/couponList';
// import VerifyCodeBtn from "../components/verifyCodeBtn";
import FinishModal from '../components/redeemPage/finishModal';
import ErrorModal from '../components/errorModal';
import Loading from '../components/loading';
import styles from '../styles/Redeem.module.scss';
import API from '../services/api';
import moment from 'moment';
import store from 'store-js';
import { useTranslation } from 'react-i18next';
import imageCompression from 'browser-image-compression';

import { faTrashAlt, faReceipt, faCancel, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCookieState } from 'ahooks';

export default function UploadReceipt({ config }) {
    const pageSetting = config.scannerErr_setting;
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { state } = useLocation();
    const redeemID = state?.redeemID; // This will be undefined if state is null

    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });

    const firstReceiptRef = useRef(null);
    const secondReceiptRef = useRef(null);

    //receipt files
    const [firstReceiptBase64, setFirstReceiptBase64] = useState('');
    const [firstReceiptFile, setFirstReceiptFile] = useState(null);

    const [secondReceiptBase64, setSecondReceiptBase64] = useState('');
    const [secondReceiptFile, setSecondReceiptFile] = useState(null);

    //options
    const [firstReceiptOption, setFirstReceiptOption] = useState(false);
    const [secondReceiptOption, setSecondReceiptOption] = useState(false);

    const [errModalMsg, setErrModalMsg] = useState(null);
    const [showServerErr, setShowServerErr] = useState(false);
    const [consoleMsg, setConsoleMsg] = useState(null);
    const [isPostingData, setIsPostingData] = useState(false);

    const [customerId, setCustomerId] = useState(null);
    const [useHistoryId, setUseHistoryId] = useState(null);

    useEffect(() => {
        setCustomerId(store.get('customerId'));
        setUseHistoryId(store.get('useHistoryId'));

        if (!token) navigate('/');
    }, []);

    const disableConfirmBtn = useMemo(() => {
        return !firstReceiptFile || !secondReceiptFile;
    }, [firstReceiptFile, secondReceiptFile]);

    const handleError = (res) => {
        setShowServerErr(true);
        setIsPostingData(false);

        switch (res?.payload?.error_code) {
            case '4518':
                setErrModalMsg('電子券使用中，請稍後再試' + ' (P1)');
                break;
            case '4520':
                setErrModalMsg(t('scannerErr_notEnoughCodes') + ' (P2)');
                break;
            case '4522':
                setErrModalMsg('電子券已使用');
                break;
            default:
                setConsoleMsg(2);
                console.log(res?.response?.message);
                break;
        }
    };

    const uploadFiles = async (file_arr) => {
        try {
            const api = new API(token);
            var options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            };
            const uploadPromises = file_arr.map(async (file) => {
                const compressedFile = await imageCompression(file, options);
                if (compressedFile) {
                    console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
                    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
                    return await api.uploadMedia(customerId, compressedFile); // Use compressedFile instead of file
                } else {
                    throw new Error('image compression failed');
                }
            });
            const results = await Promise.all(uploadPromises);
            return results;
        } catch (error) {
            console.error('Error uploading files:', error);
            return;
        }
    };

    const addAttachmentToVoucher = async (media_res_arr) => {
        const api = new API(token);
        try {
            // Update RedeemID - "F" + Clix Store ID + RedemptionYYMMDD + 4 dig random no.
            // let random = Math.floor(1000 + Math.random() * 9000);
            // let refId = `F${store.get('merchant_id')}${moment().format('YYMMDD')}${random}`;
            // let recordObj = createNewRecord(refId);

            const updateVoucherAttachmentPromise = media_res_arr?.map((media) =>
                api.updateVoucherAttachment(useHistoryId, media.token)
            );

            const res = await Promise.all(updateVoucherAttachmentPromise);

            // const res = await api.redeemVoucher(recordObj, media_res_arr);
            setIsPostingData(false);
            if (res[0].response?.code === '200') {
                // handleSuccess(refId);
                store.remove('customerId');
                store.remove('useHistoryId');
                navigate('/records');
            } else if (res[0].response?.code === '400') {
                handleError(res);
            }
        } catch (err) {
            setShowServerErr(true);
            setConsoleMsg(t('errMsg_networkErr') + err.message);
            setIsPostingData(false);
            console.log(err);
        }
    };

    const handleSubmit = async (file_arr) => {
        // setIsPostingData(true);
        if (customerId && useHistoryId) {
            if (file_arr.length > 0) {
                try {
                    const res = await uploadFiles(file_arr);
                    if (!res || res.length === 0) {
                        throw new Error('File upload failed');
                    }
                    const media_res_arr = res
                        ?.filter((r) => r?.response?.code === '200')
                        .map((r) => ({
                            media_id: r.payload.id,
                            token: r.payload.token,
                            file_path: r.payload.file_path
                        }));
                    if (media_res_arr?.length > 0) {
                        await addAttachmentToVoucher(media_res_arr);
                    } else {
                        setShowServerErr(true);
                        setErrModalMsg(`${res[0].response.code + t(pageSetting.errMsg.invalidToken)}`);
                        setIsPostingData(false);
                    }
                } catch (err) {
                    setShowServerErr(true);
                    setConsoleMsg(t('errMsg_networkErr') + err.message);
                    setIsPostingData(false);
                    console.log(err);
                }
            }
        } else {
            setShowServerErr(true);
            setConsoleMsg(t('errMsg_InvalidCustomerIdOrUseHistoryId'));
            setIsPostingData(false);
        }
    };

    const handleUploadReceipt = async () => {
        setIsPostingData(true);
        let file_arr = [];
        if (firstReceiptFile) {
            file_arr.push(firstReceiptFile);
        }
        if (secondReceiptFile) {
            file_arr.push(secondReceiptFile);
        }
        if (customerId && useHistoryId) {
            await handleSubmit(file_arr);
        } else {
            setShowServerErr(true);
            setConsoleMsg(t('errMsg_InvalidCustomerIdOrUseHistoryId'));
            setIsPostingData(false);
        }
        setIsPostingData(false);
    };

    const handleConfirm = () => {
        // if (hasInvalidData()) {
        //     return;
        // }
        setIsPostingData(true);

        // setTimeout(async () => {
        // let file_arr = [];
        // if (firstReceiptFile) {
        //     file_arr.push(firstReceiptFile);
        // }
        // if (secondReceiptFile) {
        //     file_arr.push(secondReceiptFile);
        // }
        // if (customerId && useHistoryId) {
        //     await handleSubmit(file_arr);
        // } else {
        //     setShowServerErr(true);
        //     setConsoleMsg(t('errMsg_InvalidCustomerIdOrUseHistoryId'));
        //     setIsPostingData(false);
        // }
        // }, 1000);
    };

    const handleCloseErrModal = () => {
        setShowServerErr(false);
        setConsoleMsg(null);
    };

    const onChangeReceipt = (event, type) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        if (file) {
            if (type === 'first') setFirstReceiptFile(file);
            else setSecondReceiptFile(file);

            reader.onload = function (e) {
                if (type === 'first') setFirstReceiptBase64(e.target.result);
                else setSecondReceiptBase64(e.target.result);
                // document.getElementById("image-preview").src = e.target.result;
            };

            reader.readAsDataURL(file);
        }
    };

    return (
        <div className="marginContent noselect">
            <div className={styles.content}>
                <div className={styles.inputsDiv}>
                    <>
                        <label>{t('redeem_upload_receipt_label_1')}</label>
                        <label>{t('recordsPage_recordNum') + '：' + redeemID}</label>
                        <label className="boldThemeTxt">{t('redeem_upload_receipt_label_2')}</label>
                        <div className={styles.uploadReceiptDiv}>
                            <label
                                className={
                                    firstReceiptOption === 'now' ? styles.receiptInputSelected : styles.receiptInput
                                }
                                onClick={() => firstReceiptRef.current.click()}
                                // onClick={() => setFirstReceiptOption('now')}
                            >
                                <>{t('redeem_uploadReceiptNowBtn')}</>
                            </label>
                            {/* <label
                                    className={
                                        firstReceiptOption === 'later'
                                            ? styles.receiptInputSelected
                                            : styles.receiptInput
                                    }
                                    onClick={() => {
                                        setFirstReceiptOption('later');
                                        setFirstReceiptBase64('');
                                        setFirstReceiptFile(null);
                                    }}
                                >
                                    <>{t('redeem_uploadReceiptLaterBtn')}</>
                                </label> */}
                        </div>
                        {/* {firstReceiptOption === 'now' && (
                            <button
                                className="colorBtn contBtn"
                                type="button"
                                onClick={() => firstReceiptRef.current.click()}
                            >
                                {t('redeem_uploadReceiptBtn')}
                            </button>
                        )} */}
                        <input
                            ref={firstReceiptRef}
                            id="receipt-file-upload-first"
                            type="file"
                            accept="image/*"
                            onChange={(event) => {
                                onChangeReceipt(event, 'first');
                            }}
                            key={`${moment().unix()}-first`}
                        />
                        {firstReceiptBase64 && (
                            <img
                                id="image-preview-first"
                                src={firstReceiptBase64}
                                style={{
                                    width: '120px',
                                    height: '120px',
                                    marginTop: 12
                                }}
                            />
                        )}
                        <label className="boldThemeTxt">{t('redeem_upload_receipt_label_3')}</label>
                        <div className={styles.uploadReceiptDiv}>
                            <label
                                className={
                                    secondReceiptOption === 'now' ? styles.receiptInputSelected : styles.receiptInput
                                }
                                onClick={() => secondReceiptRef.current.click()}
                                // onClick={() => setSecondReceiptOption('now')}
                            >
                                <>{t('redeem_uploadReceiptNowBtn')}</>
                            </label>
                            {/* <label
                                    className={
                                        secondReceiptOption === 'later'
                                            ? styles.receiptInputSelected
                                            : styles.receiptInput
                                    }
                                    onClick={() => {
                                        setSecondReceiptOption('later');
                                        setSecondReceiptBase64('');
                                        setSecondReceiptFile(null);
                                    }}
                                >
                                    <>{t('redeem_uploadReceiptLaterBtn')}</>
                                </label> */}
                        </div>
                        {/* {secondReceiptOption === 'now' && (
                            <button
                                className="colorBtn contBtn"
                                type="button"
                                onClick={() => secondReceiptRef.current.click()}
                            >
                                {t('redeem_uploadReceiptBtn')}
                            </button>
                        )} */}
                        <input
                            ref={secondReceiptRef}
                            id="receipt-file-upload-second"
                            type="file"
                            accept="image/*"
                            onChange={(event) => {
                                onChangeReceipt(event, 'second');
                            }}
                            key={`${moment().unix()}-second`}
                        />
                        {secondReceiptBase64 && (
                            <img
                                id="image-preview-second"
                                src={secondReceiptBase64}
                                style={{
                                    width: '120px',
                                    height: '120px',
                                    marginTop: 12
                                }}
                            />
                        )}
                    </>
                    <button
                        className="colorBtn"
                        type="button"
                        disabled={disableConfirmBtn || isPostingData}
                        style={{
                            backgroundColor: disableConfirmBtn || isPostingData ? '#888888' : config.theme.color
                        }}
                        onClick={handleUploadReceipt}
                    >
                        {t('uploadReceiptPage_confirmBtn')}
                    </button>
                </div>

                {isPostingData && (
                    <div className="loadingBg">
                        <Loading
                            className="loadingBtn"
                            color={config.theme.color}
                            style={{
                                width: '50px',
                                height: '50px'
                            }}
                        />
                    </div>
                )}

                {/* <FinishModal openModal={openFinishModal} redeemID={redeemID} t={t} config={config} /> */}

                <ErrorModal
                    openModal={showServerErr}
                    errorMsg={errModalMsg}
                    consoleMsg={consoleMsg}
                    handleCloseModal={handleCloseErrModal}
                    t={t}
                    config={config}
                />
            </div>
        </div>
    );
}
